/**
 * Escape a string to be able to use it in regexp
 * @param str
 */
export const escapeRegExp = (str: string) => {
    return str.replace(/[.*+?^${}()|[\]\\%]/g, '\\$&'); // $& means the whole matched string
};
